var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChooseA(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 89,
    viewBox: "0 0 99 89",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10938_72196)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 99C76.8381 99 99 76.8381 99 49.5C99 22.1619 76.8381 0 49.5 0C22.1619 0 0 22.1619 0 49.5C0 76.8381 22.1619 99 49.5 99Z",
    fill: "url(#paint0_linear_10938_72196)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10938_72196",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 99,
    height: 99
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 99C76.8381 99 99 76.8381 99 49.5C99 22.1619 76.8381 0 49.5 0C22.1619 0 0 22.1619 0 49.5C0 76.8381 22.1619 99 49.5 99Z",
    fill: "url(#paint1_linear_10938_72196)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10938_72196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.8803 28.3809H21.1203C19.2978 28.3809 17.8203 29.8583 17.8203 31.6809V100.981C17.8203 102.803 19.2978 104.281 21.1203 104.281H77.8803C79.7029 104.281 81.1803 102.803 81.1803 100.981V31.6809C81.1803 29.8583 79.7029 28.3809 77.8803 28.3809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5619 34.9805H26.4019C25.3084 34.9805 24.4219 35.8669 24.4219 36.9605C24.4219 38.054 25.3084 38.9405 26.4019 38.9405H43.5619C44.6554 38.9405 45.5419 38.054 45.5419 36.9605C45.5419 35.8669 44.6554 34.9805 43.5619 34.9805Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5619 62.6992H26.4019C25.3084 62.6992 24.4219 63.5857 24.4219 64.6792C24.4219 65.7727 25.3084 66.6592 26.4019 66.6592H43.5619C44.6554 66.6592 45.5419 65.7727 45.5419 64.6792C45.5419 63.5857 44.6554 62.6992 43.5619 62.6992Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7217 44.5166H71.2822C72.9389 44.5168 74.2821 45.86 74.2822 47.5166V54.1172C74.282 55.7737 72.9388 57.117 71.2822 57.1172H27.7217C26.065 57.1171 24.7219 55.7738 24.7217 54.1172V47.5166C24.7218 45.8599 26.065 44.5167 27.7217 44.5166Z",
    stroke: "#2D6CDF",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7217 45.1768H71.2822C72.5744 45.1769 73.6219 46.2245 73.6221 47.5166V54.1172C73.6219 55.4094 72.5744 56.4569 71.2822 56.457H27.7217C26.4296 56.4568 25.382 55.4093 25.3818 54.1172V47.5166C25.382 46.2245 26.4296 45.1769 27.7217 45.1768Z",
    stroke: "#2D6CDF",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2819 71.9395H27.7219C25.8993 71.9395 24.4219 73.4169 24.4219 75.2395V80.5195C24.4219 82.342 25.8993 83.8195 27.7219 83.8195H71.2819C73.1044 83.8195 74.5819 82.342 74.5819 80.5195V75.2395C74.5819 73.4169 73.1044 71.9395 71.2819 71.9395Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9798 21.1198C36.4379 21.1198 37.6198 19.9379 37.6198 18.4798C37.6198 17.0218 36.4379 15.8398 34.9798 15.8398C33.5218 15.8398 32.3398 17.0218 32.3398 18.4798C32.3398 19.9379 33.5218 21.1198 34.9798 21.1198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4994 21.1198C50.9574 21.1198 52.1394 19.9379 52.1394 18.4798C52.1394 17.0218 50.9574 15.8398 49.4994 15.8398C48.0413 15.8398 46.8594 17.0218 46.8594 18.4798C46.8594 19.9379 48.0413 21.1198 49.4994 21.1198Z",
    fill: "#2D6CDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0189 21.1198C65.4769 21.1198 66.6589 19.9379 66.6589 18.4798C66.6589 17.0218 65.4769 15.8398 64.0189 15.8398C62.5609 15.8398 61.3789 17.0218 61.3789 18.4798C61.3789 19.9379 62.5609 21.1198 64.0189 21.1198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7609 58.0805C58.5835 58.0805 60.0609 56.603 60.0609 54.7805C60.0609 52.9579 58.5835 51.4805 56.7609 51.4805C54.9384 51.4805 53.4609 52.9579 53.4609 54.7805C53.4609 56.603 54.9384 58.0805 56.7609 58.0805Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3389 68.8844C58.8109 68.8844 58.3179 68.8844 57.8691 68.856C57.3163 68.8186 56.7845 68.6294 56.3322 68.3093C55.88 67.9892 55.5248 67.5506 55.3057 67.0416L52.5211 61.5386C52.3169 61.3008 52.2149 60.9919 52.2374 60.6793C52.2599 60.3666 52.4051 60.0755 52.6413 59.8694C52.8348 59.7139 53.0761 59.6302 53.3244 59.6325C53.5071 59.6378 53.6866 59.6827 53.8503 59.764C54.014 59.8454 54.1582 59.9613 54.2728 60.1037L55.5373 61.8296L55.5565 61.8521V55.295C55.5565 54.9697 55.6857 54.6577 55.9158 54.4276C56.1458 54.1976 56.4578 54.0684 56.7831 54.0684C57.1084 54.0684 57.4204 54.1976 57.6504 54.4276C57.8805 54.6577 58.0097 54.9697 58.0097 55.295V59.585C57.9955 59.4271 58.0143 59.268 58.0649 59.1178C58.1155 58.9676 58.1969 58.8296 58.3038 58.7126C58.4108 58.5956 58.5409 58.5021 58.6859 58.4382C58.831 58.3743 58.9877 58.3412 59.1462 58.3412C59.3047 58.3412 59.4615 58.3743 59.6065 58.4382C59.7516 58.5021 59.8817 58.5956 59.9886 58.7126C60.0955 58.8296 60.1769 58.9676 60.2276 59.1178C60.2782 59.268 60.297 59.4271 60.2827 59.585V60.4793C60.2685 60.3214 60.2873 60.1623 60.3379 60.0121C60.3886 59.8619 60.4699 59.7239 60.5769 59.6069C60.6838 59.4899 60.8139 59.3964 60.959 59.3325C61.104 59.2686 61.2608 59.2356 61.4193 59.2356C61.5778 59.2356 61.7345 59.2686 61.8796 59.3325C62.0246 59.3964 62.1547 59.4899 62.2617 59.6069C62.3686 59.7239 62.45 59.8619 62.5006 60.0121C62.5512 60.1623 62.57 60.3214 62.5558 60.4793V61.1683C62.5415 61.0105 62.5603 60.8513 62.611 60.7011C62.6616 60.551 62.743 60.413 62.8499 60.2959C62.9568 60.1789 63.087 60.0855 63.232 60.0215C63.377 59.9576 63.5338 59.9246 63.6923 59.9246C63.8508 59.9246 64.0076 59.9576 64.1526 60.0215C64.2977 60.0855 64.4278 60.1789 64.5347 60.2959C64.6416 60.413 64.723 60.551 64.7736 60.7011C64.8243 60.8513 64.8431 61.0105 64.8288 61.1683V65.3507C64.8064 66.6371 64.2249 68.8058 62.1796 68.8058C62.0311 68.8124 60.7731 68.885 59.3416 68.885L59.3389 68.8844Z",
    fill: "#005AFF",
    stroke: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10938_72196",
    x1: 49.5,
    y1: 0,
    x2: 49.5,
    y2: 99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E2EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10938_72196",
    x1: 50,
    y1: 12.5,
    x2: 49.5,
    y2: 99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10938_72196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 89,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseA);
export default __webpack_public_path__ + "static/media/choose-a.4718c15f35975cc02d715e9aeb853515.svg";
export { ForwardRef as ReactComponent };